export const GET_CONFIG_SUCCESS = 'SETTINGS_SUCCESS';

export const GET_CONTENT_REQUEST = 'SETTINGS_GET_CONTENT_REQUEST';
export const GET_CONTENT_SUCCESS = 'SETTINGS_GET_CONTENT_SUCCESS';
export const GET_CONTENT_FAILURE = 'SETTINGS_GET_CONTENT_FAILURE';
